/**
 * This bootstrap file is used for both frontend and backend
 */
window.userLocale = document.querySelector("html").getAttribute("lang");

import Vue from "vue";

window._ = require("lodash");
window.printJS = require("print-js");
window.slick = require("slick-carousel");

window.Vue = Vue;

import Cookies from "js-cookie";
window.Cookies = Cookies;

require("justifiedGallery");
require("../common/components/filters/filters.js");

import Notifications from "vue-notification";
import VModal from "vue-js-modal";
import VueYoutube from "vue-youtube";
import InfiniteLoading from "vue-infinite-loading";
import VueTheMask from "vue-the-mask";
import Datepicker from "vuejs-datepicker";
import { AtomSpinner } from "epic-spinners";
import { HollowDotsSpinner } from "epic-spinners";

import VCalendar from "v-calendar";

Vue.use(VCalendar, {
    locale: window.userLocale || "ro",
    firstDayOfWeek: 2,
});

Vue.component("atom-spinner", AtomSpinner);
Vue.component("hollow-dots-spinner", HollowDotsSpinner);
Vue.component("datepicker", Datepicker);
Vue.use(VueTheMask);
Vue.use(Notifications);
Vue.use(VModal);
Vue.use(VueYoutube);

import PhoneInput from "../common/components/PhoneInput.vue";
import PhotoGallery from "../common/components/PhotoGallery.vue";
import VideoPreview from "../common/components/VideoPreview.vue";
import VideoImagePreview from "../common/components/VideoImagePreview.vue";
import Timetable from "../common/components/Timetable/Timetable.vue";
import TimetableText from "../common/components/Timetable/TimetableText.vue";
import AppNotifications from "../common/components/AppNotifications.vue";
import DateInput from "../common/components/DateInput.vue";
import DataFilterDirective from "../common/components/DataFilterDirective.vue";
import { ImgZoom } from "../common/directives/ImgZoom.js";

// Include Common Vue Components
Vue.component("phone-input", PhoneInput);
Vue.component("photo-gallery", PhotoGallery);
Vue.component("video-preview", VideoPreview);
Vue.component("video-preview-image", VideoImagePreview);
Vue.component("timetable", Timetable);
Vue.component("timetable-text", TimetableText);
Vue.component("app-notifications", AppNotifications);
Vue.component("infinite-loading", InfiniteLoading);
Vue.component("date-input", DateInput);
// Vue.component(
//     "data-filters",
//     require("../common/components/DataFilters.vue").default
// );

Vue.directive("data-filter", DataFilterDirective);
Vue.directive("img-zoom", ImgZoom);

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require("jquery");
    require("jquery-match-height");
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    // window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;

    $.ajaxSetup({
        headers: {
            "X-CSRF-TOKEN": token.content,
        },
    });
} else {
    console.error(
        "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
    );
}

/**
 * Moment is a javascript library that we can use to format dates
 * It's similar to Carbon in PHP so we mostly use it to format
 * dates that are returned from our Laravel Eloquent models
 */
window.moment = require("moment-timezone");
// Overwrite moment with moment-recur to add recur functionality
// This fixes the issue where moment.recur is not a function
window.moment = require("moment-recur");

let timezone = document.head.querySelector('meta[name="user-timezone"]');
if (timezone) {
    moment.tz.setDefault(timezone.content);
}
if (window.$) {
    moment.locale($("html").attr("lang"));
}

if (!window.eventHub) {
    window.eventHub = new Vue();
}
